<template>
	<div class="login-form grid-content">

		<el-card class="box-card panel-register-form" shadow="never">
			<div slot="header" class="clearfix">
				<h5>Recuperar contraseña</h5>
			</div>
		
		<el-form :model="ruleForm"
			         autocomplete="off"
			         label-position="left"
			         status-icon
			         :rules="rules"
			         ref="ruleForm"
			         label-width="180px"
			         class="demo-ruleForm">

					 <el-form-item prop="password" label="Contraseña" :required="true"
				              :rules="[
				            {
				                required: true,
				                message: 'Por favor ingrese contraseña', trigger: ['blur','change']
							},
				            {
				                min: 15,
				                message: 'Escriba al menos 15 caracteres', trigger: ['blur','change']
				            },
				            {
				                pattern: '.*[0-9].*',
				                message: 'Indique al menos un número', trigger: ['blur','change']
				            },
							{
								pattern: '.*[a-z]',
								message: 'Indique al menos una minuscula', trigger: ['blur','change']
							},
							{
								pattern: '.*[A-Z]',
								message: 'Indique al menos una mayúscula', trigger: ['blur','change']
							},
							{
								pattern: '.*[¡!@#$%^&*(),.¿?:{}|<>]',
								message: 'Indique al menos un carácter especial', trigger: ['blur','change']
							}
				]">

					<el-input :type="passwordType"
					          onDrag="return false"
					          onDrop="return false"
					          onPaste="return false"
					          onCut="return false"
					          v-model="ruleForm.password"
					          placeholder=""
					          autocomplete="off">
						<el-button slot="append" @click="hidePassword = !hidePassword">
							<i class="fas" :class="[passwordIcon]"></i>
						</el-button>
					</el-input>
				</el-form-item>
				<el-form-item label="Confirmar contraseña" prop="password_confirmation" :required="true">
					<el-input type="password"
					          v-model="ruleForm.password_confirmation"
					          placeholder="Confirmar contraseña"
					          onDrag="return false"
					          onDrop="return false"
					          onPaste="return false"
					          onCut="return false"
					          autocomplete="off">
					</el-input>
				</el-form-item>

				<br/>
				<el-row>
					<el-col align="end">
					<el-button type="primary" @click="submitForm('ruleForm')">Cambiar Contraseña</el-button>
					</el-col>
				</el-row>

		</el-form>


		</el-card>
	</div>
</template>

<script>

	import {mapState} from 'vuex';
	import { VueReCaptcha } from "vue-recaptcha-v3";
	import { load } from "recaptcha-v3";

	const formModel = _ => {
		return {
			email: null,
			password: null,
			password_confirmation: null,
			token: null,
			captcha: ''

		}
	};

	export default {
		components: {
			VueReCaptcha,
			load
		},
		data() {
			
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('Por favor ingrese la contraseña'));
				} else {
					if (this.ruleForm.password_confirmation !== '') {
						this.$refs.ruleForm.validateField('password_confirmation');
					}
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('Por favor ingrese la contraseña de confirmación'));
				} else if (value !== this.ruleForm.password) {
					callback(new Error('Las contraseñas no coinciden'));
				} else {
					callback();
				}
			};


			return {
				ruleForm: formModel(),
				rules: {
					password: [
						{validator: validatePass, trigger: ['blur', 'change']}
					],
					password_confirmation: [
						{validator: validatePass2, trigger: ['blur', 'change']}
					]
				},
				hidePassword: true,
				captcha:''

			}
		},

		computed: {
			...mapState([
				'route'
			]),
			passwordType() {
				return this.hidePassword ? 'password' : 'text'
			},
			passwordIcon() {
				return this.hidePassword ? 'fa-eye' : 'fa-eye-slash'
			},
			defaultValue() {
				let now = moment().subtract(18, 'years');
				return now;
			}
		},
		methods: {

			submitForm(formName) {

				this.newToken()
							.then(token => {
		
				this.ruleForm.captcha =  token;

			window.axios
			.post("/api/reset-password/reset", this.ruleForm)
            .then(response => {
              let _response = response.data.success;
              if (_response === true) {
			
					this.$store.dispatch("setAuth", response.data)
					.then(res => {
                    this.$router.push("/inicio#?");
					})
					.catch(error => {

						this.redirectF();
					});
                
              } else {
				   this.$message({
						type: "notifications/warning",
						message: "La contraseña no se cambio"
					});
              }
            })
            .catch(err => {
				this.$message({
						type: "notifications/warning",
						message: "La contraseña no se cambio, el token ha caducado."
					});
			});
			
				}).catch(error => {
							console.log("err:", error);
							this.$store.dispatch('loading/spinner', {}, {root: true});
							this.$store.dispatch('notifications/error',
								{
									msg: 'Ocurrió un error, intentelo nuevamente.'
								}, {
									root: true
								});
						});

			},
			newToken() {
				return new Promise((resolve, reject) => {
					return load(window.google).then(recaptcha => {
						return recaptcha.execute("panel")
							.then(token => {
								return resolve(token);
							}).catch(error => {
								console.log("error3:", error);
								return reject(error);
							});
					}).catch(error => {
						console.log("error2:", error);
						return reject(error);
					});
				}, error => {
					console.log("error1:", error);
					reject(error);
				})
			}
			
		},
		created() {
			var decodedString = atob(this.$route.params.email);
		     this.ruleForm.email = decodedString;
		    this.ruleForm.token = this.$route.params.id;

		},
		resetForm(formName) {
				this.$refs[formName].resetFields();
			},

	}
</script>

<style scoped>

</style>